import React from "react";
import Monogram from "./Monogram";

/**
 * Horizontal lockup: Monogram | BOOMM / GROUP
 */
export const Logo = ({ tone = "espresso", showTagline = false, compact = false }) => {
  const text = tone === "linen" ? "#F3EFE7" : "#2A2422";
  const sub = tone === "linen" ? "#B58B42" : "#6E735B";
  const monoSize = compact ? 34 : 44;
  return (
    <div className="flex items-center gap-3" data-testid="brand-logo">
      <Monogram size={monoSize} tone={tone} />
      <div className="flex items-center gap-3">
        <div
          aria-hidden="true"
          className="self-stretch"
          style={{ width: 1, backgroundColor: text, opacity: 0.5, height: compact ? 24 : 30 }}
        />
        <div className="flex flex-col leading-none">
          <span
            className="font-display"
            style={{
              color: text,
              fontWeight: 600,
              fontSize: compact ? "1.05rem" : "1.25rem",
              letterSpacing: "0.04em",
            }}
          >
            BOOMM
          </span>
          <span
            className="font-body"
            style={{
              color: sub,
              fontSize: compact ? "0.62rem" : "0.7rem",
              letterSpacing: "0.34em",
              marginTop: 3,
            }}
          >
            GROUP
          </span>
          {showTagline && (
            <span
              className="font-body"
              style={{
                color: sub,
                fontSize: "0.62rem",
                letterSpacing: "0.18em",
                marginTop: 4,
                textTransform: "uppercase",
              }}
            >
              Clarity Ignites Momentum
            </span>
          )}
        </div>
      </div>
    </div>
  );
};

export default Logo;
